/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetDeliverFeeKrGradeAmountRespVo } from './GetDeliverFeeKrGradeAmountRespVo';
import {
    GetDeliverFeeKrGradeAmountRespVoFromJSON,
    GetDeliverFeeKrGradeAmountRespVoFromJSONTyped,
    GetDeliverFeeKrGradeAmountRespVoToJSON,
    GetDeliverFeeKrGradeAmountRespVoToJSONTyped,
} from './GetDeliverFeeKrGradeAmountRespVo';

/**
 * 
 * @export
 * @interface GetDeliverFeeKrRespVo
 */
export interface GetDeliverFeeKrRespVo {
    /**
     * 数据编号
     * @type {number}
     * @memberof GetDeliverFeeKrRespVo
     */
    id?: number;
    /**
     * 仓库id
     * @type {number}
     * @memberof GetDeliverFeeKrRespVo
     */
    warehouseId?: number;
    /**
     * 运输方式
     * @type {number}
     * @memberof GetDeliverFeeKrRespVo
     */
    transportMethodId?: number;
    /**
     * 韩国国内运费分组：1橙火服务，2韩国3PL出库
     * @type {number}
     * @memberof GetDeliverFeeKrRespVo
     */
    orderTypeGroup?: number;
    /**
     * 重量起始值
     * @type {number}
     * @memberof GetDeliverFeeKrRespVo
     */
    beginValueKg?: number;
    /**
     * 重量结束值
     * @type {number}
     * @memberof GetDeliverFeeKrRespVo
     */
    endValueKg?: number;
    /**
     * 三边合起始值
     * @type {number}
     * @memberof GetDeliverFeeKrRespVo
     */
    beginValueCm?: number;
    /**
     * 三边合结束值
     * @type {number}
     * @memberof GetDeliverFeeKrRespVo
     */
    endValueCm?: number;
    /**
     * 等级金额
     * @type {Array<GetDeliverFeeKrGradeAmountRespVo>}
     * @memberof GetDeliverFeeKrRespVo
     */
    gradeAmounts?: Array<GetDeliverFeeKrGradeAmountRespVo>;
}

/**
 * Check if a given object implements the GetDeliverFeeKrRespVo interface.
 */
export function instanceOfGetDeliverFeeKrRespVo(value: object): value is GetDeliverFeeKrRespVo {
    return true;
}

export function GetDeliverFeeKrRespVoFromJSON(json: any): GetDeliverFeeKrRespVo {
    return GetDeliverFeeKrRespVoFromJSONTyped(json, false);
}

export function GetDeliverFeeKrRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDeliverFeeKrRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'warehouseId': json['warehouseId'] == null ? undefined : json['warehouseId'],
        'transportMethodId': json['transportMethodId'] == null ? undefined : json['transportMethodId'],
        'orderTypeGroup': json['orderTypeGroup'] == null ? undefined : json['orderTypeGroup'],
        'beginValueKg': json['beginValueKg'] == null ? undefined : json['beginValueKg'],
        'endValueKg': json['endValueKg'] == null ? undefined : json['endValueKg'],
        'beginValueCm': json['beginValueCm'] == null ? undefined : json['beginValueCm'],
        'endValueCm': json['endValueCm'] == null ? undefined : json['endValueCm'],
        'gradeAmounts': json['gradeAmounts'] == null ? undefined : ((json['gradeAmounts'] as Array<any>).map(GetDeliverFeeKrGradeAmountRespVoFromJSON)),
    };
}

export function GetDeliverFeeKrRespVoToJSON(json: any): GetDeliverFeeKrRespVo {
    return GetDeliverFeeKrRespVoToJSONTyped(json, false);
}

export function GetDeliverFeeKrRespVoToJSONTyped(value?: GetDeliverFeeKrRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'warehouseId': value['warehouseId'],
        'transportMethodId': value['transportMethodId'],
        'orderTypeGroup': value['orderTypeGroup'],
        'beginValueKg': value['beginValueKg'],
        'endValueKg': value['endValueKg'],
        'beginValueCm': value['beginValueCm'],
        'endValueCm': value['endValueCm'],
        'gradeAmounts': value['gradeAmounts'] == null ? undefined : ((value['gradeAmounts'] as Array<any>).map(GetDeliverFeeKrGradeAmountRespVoToJSON)),
    };
}

